import {
  File,
  FileArchive,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileType,
  type LucideIcon,
} from 'lucide-react'

/** Distinct glyphs rather than colours, which the design system does not define. */
export const FILE_ICONS: Record<string, LucideIcon> = {
  pdf: FileText,
  doc: FileType,
  docx: FileType,
  odt: FileType,
  rtf: FileType,
  txt: FileType,
  xls: FileSpreadsheet,
  xlsx: FileSpreadsheet,
  csv: FileSpreadsheet,
  png: FileImage,
  jpg: FileImage,
  jpeg: FileImage,
  gif: FileImage,
  webp: FileImage,
  heic: FileImage,
  tif: FileImage,
  tiff: FileImage,
  bmp: FileImage,
  zip: FileArchive,
  rar: FileArchive,
  '7z': FileArchive,
}

export const DEFAULT_FILE_ICON = File

/** The key `FILE_ICONS` is looked up by. */
export function fileExtension(fileName: string | null | undefined): string {
  return fileName?.split('.').pop()?.toLowerCase() ?? ''
}
